import React from "react";
import { ThemeProvider } from "../../../../theme/styled";
import type { DialogProps } from "../DialogBase";
import { DialogBase } from "../DialogBase";
import { onCloseDialog } from "../util";

export const MultiStep = ({
  title,
  onClose,
  open,
  children,
  ariaLabelCloseIcon,
  ariaLabel,
  onDismissFocusRef,
  icon,
  illustration,
  Illustration,
  alignIllustration,
  width,
  dataTestId,
  hideCloseButton,
  dialogAlignment,
  drawerSize,
}: DialogProps): React.JSX.Element | null => {
  const closeHandler = (): void =>
    onCloseDialog({ onDismissFocusRef, onClose });

  if (!open) return null;

  return (
    <ThemeProvider theme="dark">
      <DialogBase
        alignIllustration={alignIllustration}
        ariaLabel={ariaLabel}
        open={open}
        title={title}
        onClose={closeHandler}
        ariaLabelCloseIcon={ariaLabelCloseIcon}
        onDismissFocusRef={onDismissFocusRef}
        icon={icon}
        illustration={illustration}
        Illustration={Illustration}
        dataTestId={dataTestId}
        width={width}
        hideCloseButton={hideCloseButton}
        dialogAlignment={dialogAlignment}
        drawerSize={drawerSize}
        backgroundColor="!!$green500"
      >
        {children}
      </DialogBase>
    </ThemeProvider>
  );
};
